import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/generate-sale", "documento": "invoices", "acceso": "sesion", "filas": ["022"], "cita": "prod:Areas/Invoices/Controllers/GenerateController.cs:50"} satisfies RutaProd;
